import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, makeStyles } from '@material-ui/core';
import 'react-toastify/dist/ReactToastify.css';
import MenuControl from './MenuControl';
import { ButtonShowMenu } from 'src/app/components/button/ButtonMenu';
import {
  getListVehicleTrackingById,
  getListVehicleTrackingByUserId,
} from 'src/features/vehicleSlice';
import { useDispatch, useSelector } from 'react-redux';
import useVehicleTracking from 'src/app/hooks/useVehicleTracking';

const INTERVAL = 10000;

const MonitorView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const isUser = useSelector(state => state.authSlice.isUser);
  const userId = useSelector(state => state.authSlice.userId);
  const agencyId = useSelector(state => state.authSlice.agencyId);
  const adminId = useSelector(state => state.authSlice.adminId);
  const trackingId = adminId ?? agencyId;

  const deviceSerial = useSelector(state => state.videoSlice.deviceSerial);

  const fetchData = () => {
    if (trackingId) {
      dispatch(
        getListVehicleTrackingById({
          id: trackingId,
          data: {
            device_type_id: 1
          }
        })
      );
    }
  };

  const fetchDataByUserId = () => {
    dispatch(
      getListVehicleTrackingByUserId({
        id: userId,
        data: {
          device_type_id: 1
        }
      })
    );
  };

  useEffect(() => {
    let intervalId;
    fetchData();
    if (isUser) {
      fetchDataByUserId();
      intervalId = window.setInterval(fetchDataByUserId, INTERVAL);
    }
    return () => {
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    };
  }, [isAdmin, isAgency, isUser, dispatch]);

  useVehicleTracking();

  const [showMenu, setShowMenu] = React.useState(true);

  return (
    <div className={classes.root}>
      <ButtonShowMenu setShowMenu={setShowMenu} showMenu={showMenu} />
      <MenuControl
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        deviceSerial={deviceSerial}
        fetchData={fetchData}
        fetchDataByUserId={fetchDataByUserId}
      />

      <Box
        style={{
          flex: 1,
          //overflowY: 'auto',
          zIndex: 10
        }}
      >
        <Outlet />
      </Box>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    overflow: 'hidden',
    position: 'relative',
    height: 'calc(100vh - 66px)'
  }
}));

export default React.memo(MonitorView);
